import React from "react";
import { AppRemoveIcon } from "../../Icon/AppRemoveIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const TrashBinButton = (props: IAppButtonProps) => (
    <AppButton
        variant="outlined"
        startIcon={<AppRemoveIcon />}
        sx={{ marginRight: "24px" }}
        {...props}>
        {props.children}
    </AppButton>
);
